import { useState } from "react";
import { Button } from "reactstrap";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faKey } from "@fortawesome/free-solid-svg-icons";
import { FormattedMessage, useIntl } from "react-intl";
import axios from "../../services/api/api";
import { formatServiceError } from "../../Utilities/serviceErrorHelper";
import CopyUrlDialog from "../Modal/CopyUrlDialog";

export default function ButtonCreatePasswordResetLink({ email }) {
  const intl = useIntl();
  const [link, setLink] = useState(null);

  const createLink = () => {
    axios
      .post(`/User/CreatePasswordResetLink?email=${encodeURIComponent(email)}`)
      .then((res) => setLink(res.data))
      .catch((err) =>
        toast.warn(formatServiceError(intl, err?.response?.data)),
      );
  };

  return (
    <>
      <Button outline size="sm" color="primary" onClick={createLink}>
        <FontAwesomeIcon icon={faKey} className="me-1" />
        <FormattedMessage id="CreatePasswordResetLink" />
      </Button>
      <CopyUrlDialog
        isOpen={link !== null}
        title={<FormattedMessage id="PasswordResetLinkCreatedCopyUrl" />}
        url={link?.url}
        note={
          <FormattedMessage
            id="PasswordResetLinkValidFor"
            values={{ hours: link?.validForHours }}
          />
        }
        onClose={() => setLink(null)}
      />
    </>
  );
}
